<template>
  <div>
    <!-- 顶部导航 -->
    <m-header></m-header>
    <!-- 外层wrap -->
    <div class="memberWrap">
      <!-- 版心 -->
      <div class="memberBox">
        <!-- 头部 -->
        <header class="memberHeader">
          <div class="memberTitle">
            <h1>欢迎加入我们的会员</h1>
            <span>成为我们的会员，享受专属特权和丰富的资源。</span>
          </div>
          <!-- 登录/注册表单区域 -->
          <div class="loginForm" ref="loginForm">
            <h1>欢迎加入我们的会员</h1>
            <p>成为我们的会员，享受专属特权和丰富的资源。</p>
            <!-- 登录注册 -->
            <div class="formArea">
              <div class="fromBox">
                <!-- 切换手机邮箱tab -->
                <ul class="chgetab">
                  <li v-for="item in tabList" :key="item.id" :class="{ 'act': item.id == tabItem.id }"
                    @click="changeTab(item)">{{ item.name }}</li>
                </ul>
                <!-- 表单区域 -->
                <div class="form">
                  <!-- 登录区域  -->
                  <template v-if="!actionType.isRegister && !actionType.isChangePwd">
                    <!-- 手机登录 -->
                    <el-form class="phoneLoginForm" v-if="tabItem.id == tabList[0].id" ref="formTel" :rules="formTelRules"
                      :model="formTel">
                      <!-- 手机号 -->
                      <el-form-item class="formitem" prop="phone">
                        <el-input @input="handleInput" v-model.number="formTel.phone" :maxlength="11"
                          placeholder="请输入手机号"></el-input>
                      </el-form-item>
                      <!-- 验证码 -->
                      <el-form-item class="formitem formitem_telcode" prop="sms">
                        <el-input v-model="formTel.sms" placeholder="验证码"></el-input>

                        <span v-if="!this.timerObj.telTime.num" class="telcode"
                          @click="telCodeFun('formTel')">获取验证码</span>
                        <span v-else class="telcode">{{ this.timerObj.telTime.num }}s</span>
                      </el-form-item>
                      <!-- 邀请码 -->
                      <el-form-item class="formitem formitem_inviteCode" prop="inviteCode">
                        <el-input v-model="inviteCode" placeholder="填写邀请码（非必填）"></el-input>
                        <span class="invitecode">邀请码</span>
                      </el-form-item>
                    </el-form>

                    <!-- 邮箱登录 -->
                    <el-form class="emailLoginForm" v-else-if="tabItem.id == tabList[1].id" ref="formEmail"
                      :rules="formEmailRules" :model="formEmail">
                      <!-- 邮箱 -->
                      <el-form-item class="formitem formitem_email" prop="email">
                        <el-input v-model="formEmail.email" placeholder="请输入邮箱"></el-input>
                      </el-form-item>
                      <!-- 密码 -->
                      <el-form-item class="formitem formitem_password" prop="password">
                        <el-input v-model="formEmail.password" placeholder="请输入密码" type="password"></el-input>

                        <span class="forgetpwd" @click="forgetPwd()">忘记密码</span>
                      </el-form-item>
                    </el-form>
                    <button class="btn" type="submit" @click="submitForm('login')">登 录</button>
                  </template>

                  <!-- 注册区域 -->
                  <template v-else>
                    <!-- 邮箱注册 -->
                    <el-form class="registerForm" v-if="actionType.id == tabList[1].id" ref="formEmailReg"
                      :model="formEmailReg" :rules="formEmailRegRules" :show-message="false">
                      <!-- 邮箱 -->
                      <el-form-item class="formitem" prop="email">
                        <el-input v-model="formEmailReg.email" placeholder="请输入邮箱"></el-input>
                      </el-form-item>
                      <!-- 密码 -->
                      <el-form-item class="formitem" prop="newPwd">
                        <el-input type="password" v-model="formEmailReg.newPwd" placeholder="密码"></el-input>
                      </el-form-item>
                      <!-- 确认密码 -->
                      <el-form-item class="formitem" prop="oldPwd">
                        <el-input type="password" v-model="formEmailReg.oldPwd" placeholder="确认密码"></el-input>
                      </el-form-item>
                      <!-- 验证码 -->
                      <el-form-item class="formitem" prop="randomCode">
                        <el-input v-model="formEmailReg.randomCode" placeholder="验证码"></el-input>

                        <span class="emailcode" v-if="!this.timerObj.emailTimer.num"
                          @click="emailCodeFun('formEmailReg')">获取验证码</span>
                        <span class="emailcode" v-else>{{ this.timerObj.emailTimer.num }}s</span>
                      </el-form-item>
                      <!-- 邀请码 -->
                      <el-form-item class="formitem" prop="inviteCode">
                        <el-input v-model="inviteCode" placeholder="填写邀请码（非必填）"></el-input>
                        <span class="invitecode">邀请码</span>
                      </el-form-item>
                    </el-form>
                  </template>

                  <!-- 用户协议 -->
                  <div class="ischeck" v-if="!actionType.isChangePwd">
                    <el-checkbox v-if="regFlag === true" class="checkbox_reg" label v-model="isChecked"></el-checkbox>
                    <el-checkbox v-else-if="regFlag === false" class="checkbox" label v-model="isChecked"></el-checkbox>
                    <span v-if="regFlag === true" class="reg_1">已阅读并同意</span>
                    <span v-else-if="regFlag === false">已阅读并同意</span>
                    <a v-if="regFlag === true" class="reg_2" @click="dialogTableVisible = true">《用户服务条款》</a>
                    <a v-else-if="regFlag === false" @click="dialogTableVisible = true">《用户服务条款》</a>
                  </div>

                  <!-- btn -->
                  <button class="btn_reg" v-if="actionType.isRegister && regFlag == true" type="submit"
                    @click="submitForm('register')">注 册</button>
                  <button class="btn" v-if="actionType.isRegister && regFlag == false" type="submit"
                    @click="submitForm('register')">注 册</button>
                  <button class="btn" v-else-if="actionType.isChangePwd && regFlag == true" type="submit"
                    @click="submitForm('pwd')">提 交</button>
                  <button class="btn" v-else-if="actionType.isChangePwd && regFlag == false" type="submit"
                    @click="submitForm('pwd')">提 交</button>

                  <!-- 邮箱注册 -->
                  <div v-if="tabItem.id == tabList[1].id">
                    <!-- 如果是注册或者修改密码 -->
                    <span class="backlogin" v-if="actionType.isRegister || actionType.isChangePwd"
                      @click="goBackLogin()">返回登录</span>
                    <span class="registerRight" v-else @click="registerFun">注册</span>
                  </div>

                </div>
              </div>
              <!-- 用户协议弹窗 -->
              <el-dialog width="1000" :visible.sync="dialogTableVisible" title="请您仔细阅读以下内容" :close-on-click-modal="false"
                :close-on-press-escape="false">
                <div>
                  <el-main>
                    <m-userPro></m-userPro>
                  </el-main>
                </div>

                <div>
                  <el-button type="primary" @click="agreeProtocol">我已阅读并同意以上协议 </el-button>
                </div>
              </el-dialog>

              <!-- 其他登录 -->
              <div class="otherlogin">
                <div class="otherlogintxt">其他登录</div>
                <ul>
                  <li class="wechat" aria-label="微信登录" @click="otherLogin('WECHAT_OPEN')">
                    <img src="@/assets/wechat.png" alt="">
                  </li>
                  <li class="QQicon" aria-label="QQ登录" @click="otherLogin('QQ')">
                    <img src="@/assets/QQicon.png" alt="">
                  </li>
                </ul>

                <div v-clickoutside="linkNone" class="link-code">
                  <img v-if="isLinkBlock" src="@/assets/link.png" alt="">
                  <span @click="linkBlock">联系客服</span>
                </div>
              </div>
            </div>
          </div>
        </header>
        <!-- 会员价格区域 -->
        <div class="memberPrice">
          <div class="priceTitle">
            <h1>会员价格</h1>
            <p>我们提供多种会员价位，以满足不同用户的需求。</p>
          </div>
          <div class="priceList">
            <div class="priceItem" @mouseover="mouseover(index)" @mouseout="mouseout"
              :class="{ 'active': activeFlag === index }" v-for="(item, index) in priceData" :key="item.id">
              <div class="vipType">{{ item.vipType }}VIP</div>
              <div class="vipPrice">¥{{ item.vipPrice }}/{{ item.vipDate }}</div>
              <div class="vipDesc">
                <div class="descItem">
                  <img v-if="activeFlag === index" src="@/assets/member/checkedAct.png" alt="">
                  <img v-else src="@/assets/member/checked.png" alt="">
                  <span>赠送{{ item.points }}积分</span>
                </div>
                <div class="descItem">
                  <img v-if="activeFlag === index" src="@/assets/member/checkedAct.png" alt="">
                  <img v-else src="@/assets/member/checked.png" alt="">
                  <span v-if="item.type === 3">免费模型下载无限制</span>
                  <span v-else>免费模型下载{{ item.freeModelNum }}个/天</span>

                </div>
                <div class="descItem">
                  <img v-if="activeFlag === index" src="@/assets/member/checkedAct.png" alt="">
                  <img v-else src="@/assets/member/checked.png" alt="">
                  <span v-if="item.type === 3">会员模型免费下载无限制</span>
                  <span v-else>会员模型免费下载{{ item.memberModelNum }}个/天</span>
                </div>
                <div class="descItem">
                  <img v-if="activeFlag === index" src="@/assets/member/checkedAct.png" alt="">
                  <img v-else src="@/assets/member/checked.png" alt="">
                  <span>付费模型{{ item.paymentModel }}折</span>
                </div>
              </div>
              <el-button class="buyNowBtn" @click="buyNowBtn">立即购买</el-button>
            </div>
          </div>

        </div>
        <!-- VIP会员权益 -->
        <div class="vipMemberRight">
          <div class="priceTitle">
            <h1>VIP会员权益</h1>
            <p>选择适合您的会员套餐</p>
          </div>
          <div class="memberRightBottom">
            <ul class="memRightType">
              <li v-for="(item, index) in memRightType" :key="index">{{ item }}</li>
            </ul>
            <ul class="ordinaryUser" @mouseover="mouseoverMemUser(0)" @mouseout="mouseoutMemberRight"
              :class="{ 'act': actFlag === 0 }">
              <li v-for="(item, index) in ordinaryUser" :key="index">{{ item }}</li>
            </ul>
            <div class="vipMemberWrap">
              <ul class="vipMemberList" v-for="item in memberRigPriData" :key="item.id"
                @mouseover="mouseoverMemberRight(item.type)" @mouseout="mouseoutMemberRight"
                :class="{ 'act': actFlag === item.type }">
                <li>{{ item.vipType }}VIP</li>
                <li>{{ item.vipPrice }}元/{{ item.vipDate }}</li>
                <li v-if="item.freeModelNum == '无限制'">无限制</li>
                <li v-else>{{ item.freeModelNum }}个/天</li>
                <li>
                  <img v-if="actFlag === item.type" src="@/assets/member/check_2.png" alt="">
                  <img v-else src="@/assets/member/check_1.png" alt="">
                </li>
                <li>{{ item.paymentModel }}折</li>
                <li>
                  <img v-if="actFlag === item.type" src="@/assets/member/check_2.png" alt="">
                  <img v-else src="@/assets/member/check_1.png" alt="">
                </li>
                <li>
                  <img v-if="actFlag === item.type" src="@/assets/member/check_2.png" alt="">
                  <img v-else src="@/assets/member/check_1.png" alt="">
                </li>
                <li>
                  <img v-if="actFlag === item.type" src="@/assets/member/check_2.png" alt="">
                  <img v-else src="@/assets/member/check_1.png" alt="">
                </li>
                <li>{{ item.points }}积分</li>
                <li>极速下载</li>
              </ul>
            </div>
          </div>
        </div>

        <!-- 会员特权 -->
        <div class="MembershipPiv">
          <div class="MembershipPivTitle">
            <h1>会员特权</h1>
            <p>成为本站会员，您将享受到以下特权：</p>
          </div>
          <div class="MembershipType">
            <ul>
              <li v-for="(item, index) in MembershipType" :key="index">
                <div class="MembershipPic">
                  <img :src="item.url" alt="">
                </div>
                <p class="MembershipName">{{ item.name }}</p>
                <p class="MembershipValue">{{ item.value }}</p>
              </li>
            </ul>
          </div>
        </div>

        <!-- 会员开通专区 -->
        <div class="MembershipArea">
          <div class="memberShipAreaModel">
            <div class="memberShipAreaModelTitle">
              <span class="ipt"><img src="@/assets/member/arrowUp.png" alt=""></span>
              <span class="txt">VIP模型专区</span>
            </div>
            <p>VIP会员专区模型免费下载</p>
            <p>不同套餐特权不同，选择适合您的</p>
            <p>最高会员专区无限下载</p>
            <p>会员专区模型不限速下载</p>
            <div class="OpenImmediae" @click="OpenImmedMember">
              立即开通 <span>></span>
            </div>
          </div>
          <div class="memberShipAreaModel">
            <div class="memberShipAreaModelTitle">
              <span class="ipt1"><img src="@/assets/member/dableMem.png" alt=""></span>
              <span class="txt">会员双倍积分</span>
            </div>
            <p>会员每日登录就送双倍积分</p>
            <p>会员充值积分9.5折</p>
            <p>开通会员就送海量积分</p>
            <div style="margin-top: 65px;" class="OpenImmediae" @click="OpenImmedMember">
              立即开通 <span>></span>
            </div>
          </div>
          <div class="memberShipAreaModel">
            <div class="memberShipAreaModelTitle">
              <span class="ipt"><img src="@/assets/member/star.png" alt=""></span>
              <span class="txt">免费模型下载</span>
            </div>
            <p>最高免费模型不限量下载</p>
            <p>会员专享极速下载</p>
            <p>会员购买搜币模型享折扣</p>
            <p>专享客服</p>
            <div class="OpenImmediae" @click="OpenImmedMember">
              立即开通 <span>></span>
            </div>
          </div>
        </div>

        <!-- 帮助中心 -->
        <div class="helpCenter">
          <div class="helpCenterTitle">
            <h1>帮助中心</h1>
            <p>这里放常见问答</p>
          </div>
          <div class="helpCenterContentTitle">
            有任何问题，请随时联系我们。
          </div>
          <div class="helpCenterContent">
            <div v-clickoutside="handleClickontactUs" class="code" v-if="ishidden">
              <img src="@/assets/link.png" alt="">
              <p>
                扫码联系客服
              </p>
            </div>
            <div @click="contactUs" class="helpCenterContentBox">
              <div class="ipt"><img src="@/assets/member/contactUs.png" alt=""></div>
              <p>联系我们</p>
            </div>
            <div v-clickoutside="handleClickation" class="code_1" v-if="ishiddation">
              <img src="@/assets/link.png" alt="">
              <p>
                扫码联系客服
              </p>
            </div>
            <div @click="cooperation" class="helpCenterContentBox">
              <div class="ipt"><img src="@/assets/member/cooperation.png" alt=""></div>
              <p>商务合作</p>
            </div>
            <div @click="earnPoints" class="helpCenterContentBox">
              <div class="ipt"><img src="@/assets/member/earnPoints.png" alt=""></div>
              <p>赚取积分</p>
            </div>
            <div @click="problemFn" class="helpCenterContentBox">
              <div class="ipt"><img src="@/assets/member/Q&A.png" alt=""></div>
              <p>常见问题</p>
            </div>
          </div>
        </div>

        <!-- 常见问题 -->
        <div ref="targetLocation" class="usualQuest">
          <div class="usualQuestTitle">
            <h1>常见问题</h1>
            <p>Q & A</p>
          </div>
          <div class="usualQuestContent">
            <p>1.开通会员可以下载全部模型吗？</p>
            <p>A：开通对应会员享受对应权益，比如开通钻石VIP可以下载会员专区模型和免费模型，积分模型和搜币模型还是需要扣除相应的货币。</p>
            <p>2.开通会员可以开发票吗？</p>
            <p>A：开通会员需金额满100及以上才可以开发票，发票种类为：普通纸质发票，开票类型：设计服务费，具体开票细节请联系客服，开发票请用微信支付。</p>
            <p>3.开通会员就送相应积分吗？</p>
            <p>A：对的，开通一年黄金VIP送5000积分，开通两年送12000积分（多送2000积分），开通三年送18000积分（多送3000积分）。</p>
            <p>4.积分会过期吗？</p>
            <p>A：积分不会过期，用完为止。</p>
            <p>5.积分可以单独充值吗？</p>
            <p>A:积分可以单独充值，请跳转到我们<a style="cursor: pointer;" @click="pointRecharge">积分充值</a>。</p>
            <p>6.积分还有其他获取渠道吗？</p>
            <p>A:有的，上传模型经过审核以及每日登录都会送积分的。</p>
            <p>7.购买的会员可以退款吗？</p>
            <p>A：不支持退款，请理性消费，谨慎购买。</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 会员充值弹窗 -->
    <openMembership @changeIsHidden="changeIshiddenState" v-clickoutside="handleClickOutside" v-if="isVisible"
      :memberType="memberType"></openMembership>
    <openPointRecharge v-if="isHidden" v-clickoutside="pointRechClickOutside"></openPointRecharge>
  </div>
</template>

<script>
import openMembership from '@/components/openMembership/index.vue'
import openPointRecharge from '@/components/openPointRecharge/index.vue'
import Clickoutside from 'element-ui/src/utils/clickoutside'
import { mapMutations } from 'vuex'
import { checkInviteCode, myAccountApi } from "@/api/user";
import {
  telCodeApi,
  emailCodeApi,
  emailLoginApi,
  emailPwdApi,
  telLoginApi,
  otherLoginApi
} from "@/api/login";
const timeMax = 120;
export default {
  directives: { Clickoutside },
  name: 'member',
  components: {
    openMembership,
    openPointRecharge
  },
  data () {
    var checkCode = (rule, value, callback) => {
      if (this.inviteCode) {
        let reg = /^\d{8}$/
        if (this.inviteCode.match(reg)) {
          checkInviteCode({ inviteCode: this.inviteCode }).then(res => {
            if (res.code == 200 && res.message == 'ok') {
              callback()
            } else {
              callback(new Error('活动邀请码错误，无邀请码可不填'));
            }
          })
            ;
        } else {
          callback(new Error('活动邀请码错误，无邀请码可不填'));
        }
      } else {
        callback();
      }
    };
    var checkPhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'))

      } else if (!/^1(3|4|5|6|7|8|9)[0-9]\d{8}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }

    return {
      regFlag: false,
      priceData: [ // 会员价格列表
        {
          id: 1,
          type: 1,
          vipType: '白银',
          vipPrice: 29,
          vipDate: '月',
          points: 600,
          freeModelNum: 10,
          memberModelNum: 5,
          paymentModel: 9.8
        },
        {
          id: 2,
          type: 2,
          vipType: '黄金',
          vipPrice: 199,
          vipDate: '年',
          points: 5000,
          freeModelNum: 50,
          memberModelNum: 30,
          paymentModel: 9.5
        },
        {
          id: 3,
          type: 3,
          vipType: '钻石',
          vipPrice: 399,
          vipDate: '年',
          points: 10000,
          freeModelNum: "无限制",
          memberModelNum: "无限制",
          paymentModel: 9.5
        }
      ],
      memberRigPriData: [
        {
          id: 2,
          type: 2,
          vipType: '黄金',
          vipPrice: 199,
          vipDate: '年',
          points: 5000,
          freeModelNum: 50,
          memberModelNum: 50,
          paymentModel: 9.5
        },
        {
          id: 1,
          type: 1,
          vipType: '白银',
          vipPrice: 29,
          vipDate: '月',
          points: 600,
          freeModelNum: 10,
          memberModelNum: 10,
          paymentModel: 9.8
        },
        {
          id: 3,
          type: 3,
          vipType: '钻石',
          vipPrice: 399,
          vipDate: '年',
          points: 10000,
          freeModelNum: "无限制",
          memberModelNum: "无限制",
          paymentModel: 9.5
        }
      ],
      activeFlag: null, // 鼠标悬浮会员价格高亮
      actFlag: 2, // 鼠标悬浮会员权益高亮
      memRightType: ['', '专享高品质3D模型下载', '免费模型下载特权', '会员免费专区', '折扣特权', '登录享双倍积分', '活动特权', '专享服务', '附赠积分', '下载特权'],
      ordinaryUser: ['普通用户', '', '5个/天', '', '', '', '', '', '', '500KB/S'],
      MembershipType: [
        {
          url: require('../assets/member/MemberHorGe.png'),
          name: '会员尊贵标识',
          value: '专属会员标识'
        },
        {
          url: require('../assets/member/MemberPrice.png'),
          name: '会员价格',
          value: '以优惠的价格购买模型，尽享更多高质量3D模型'
        },
        {
          url: require('../assets/member/IntegralEquity.png'),
          name: '积分权益',
          value: '开通会员享海量积分'
        },
        {
          url: require('../assets/member/FreeMembers.png'),
          name: '会员免费专区',
          value: '会员专区模型下载特权，让您专注于作品创作'
        },
        {
          url: require('../assets/member/LoginDoublepoint.png'),
          name: '登录双倍积分',
          value: '会员每日登录享双倍积分'
        },
        {
          url: require('../assets/member/ActivityPriv.png'),
          name: '活动特权',
          value: '会员将有机会参与各种专属活动，赢取丰厚奖品'
        },
        {
          url: require('../assets/member/ExclusiveService.png'),
          name: '专享服务',
          value: '会员享受一对一专属客服服务，更快速解决问题'
        },
        {
          url: require('../assets/member/MorePriv.png'),
          name: '更多特权',
          value: '会员还将享受更多特权，敬请期待'
        }
      ],
      tabList: [ // 登录注册tab切换
        {
          name: "手机登录",
          formName: "formTel",
          id: 0,
        },
        {
          name: "邮箱登录",
          formName: "formEmail",
          id: 1,
        },
      ],
      actionType: { // 注册类型
        /* 是否为忘记密码 */
        isChangePwd: false,
        /* 是否为注册 */
        isRegister: false,
        /* 注册类型id */
        id: 1,
        islogin: false
      },
      tabItem: {
        name: "手机登录",
        formName: "formTel",
        id: 0,
      },
      formTelRules: { // 手机登录验证规则
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/,
            message: "请正确输入手机号",
            trigger: "blur",
          },
        ],
        sms: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        inviteCode: [
          { validator: checkCode, trigger: 'blur' }
        ],
      },
      formEmailRules: {
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },

        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      /* 手机登录数据 */
      formTel: {
        phone: "",
        sms: "",
      },
      timerObj: {
        /* 手机号登录倒计时 */
        telTime: {
          loading: false,
          obj: null,
          num: 0,
        },
        /* 邮箱发送倒计时 */
        emailTimer: {
          loading: false,
          obj: null,
          num: 0,
        },
      },

      formEmail: {
        email: "",
        randomCode: "",
        password: "",
      },
      formEmailReg: {
        email: "",
        /* 只要发验证码就是0 */
        type: 0,
        newPwd: "",
        oldPwd: "",
        password: "",
        randomCode: "",
      },
      formEmailRegRules: {
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            pattern:
              /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,}$/,
            message: "请正确输入邮箱",
            trigger: "blur",
          },
        ],
        newPwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            pattern:
              /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/,
            message: "密码必须是由8-20位字母+数字组合",
            trigger: "blur",
          }
        ],
        oldPwd: [
          { required: true, message: "请确认密码", trigger: "blur" },
          {
            pattern:
              /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/,
            message: "密码必须是由8-20位字母+数字组合",
            trigger: "blur",
          }
        ],
        randomCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        inviteCode: [
          { validator: checkCode, trigger: 'blur' }
        ],
      },
      memberType: null,
      isVisible: false, // vip充值类型组件显示隐藏
      isHidden: false, // 积分组件显示隐藏
      isChecked: false,
      dialogTableVisible: false,
      inviteCode: '',
      ishidden: false, // 联系我们
      ishiddation: false, // 商务合作
      isLinkBlock: false, // 联系客服二维码显示隐藏
    }
  },
  created () {

    let inviteCode = localStorage.getItem("inviteCode")
    if (inviteCode) {
      this.inviteCode = inviteCode
    }
  },
  methods: {
    ...mapMutations({
      SET_USER_INFO: 'SET_USER_INFO'
    }),
    linkBlock () {
      this.isLinkBlock = true
    },
    linkNone () {
      this.isLinkBlock = false
    },

    handleInput (value) { // 手机登录验证
      const reg = /^[\d\.]+$/;

      if (value && !reg.test(value)) {
        this.formTel.phone = value.replace(/[^0-9]/g, '');
      }
    },
    handleEmailIpt (val) {
      console.log(val, 'nnnnn');
    },
    /**
     * @desc 鼠标移入/移出 会员价格盒子高亮
     */
    mouseover (index) {
      this.activeFlag = index
    },
    mouseout () {
      this.activeFlag = null
    },
    /**
     * @desc 鼠标移入/移出 会员权益盒子高亮
     */
    mouseoverMemberRight (type) {
      this.actFlag = type
    },
    mouseoutMemberRight () {
      this.actFlag = 2
    },
    mouseoverMemUser (type) {
      this.actFlag = type
    },
    /**
     * @点击立即购买
     */
    buyNowBtn () {
      this.$message({
        type: 'error',
        message: '请先登录后再购买会员！'
      })
      const loginForm = this.$refs.loginForm;
      loginForm.scrollIntoView(false);
    },
    /**
      * @点击会员充值组件之外的区域 组件消失
      */
    handleClickOutside () {
      this.isVisible = false
    },
    /**
     * @点击积分充值组件之外的区域 组件消失
     */
    pointRechClickOutside () {
      this.isHidden = false
    },
    /**
      * @desc 点击立即开通按钮
      */
    OpenImmedMember () {
      this.$message({
        type: 'error',
        message: '请先登录后再购买会员！'
      })
      const loginForm = this.$refs.loginForm;
      loginForm.scrollIntoView(false);
    },
    /**
     * @desc 积分充值
     */
    pointRecharge () {
      this.$message({
        type: 'error',
        message: '请先登录后再购买积分！'
      })
      const loginForm = this.$refs.loginForm;
      loginForm.scrollIntoView(false);
    },
    changeIshiddenState (state) {
      this.isHidden = state
      this.isVisible = false
    },
    /**
     * @desc 登录注册tab切换
     */
    changeTab (item, flag = true) {

      if (this.regFlag == true) {
        this.regFlag = false
      }
      if (item.id == this.tabItem.id && flag) {
        return false;
      }

      /* 重置表单 */
      this.resetForm("formTel");
      this.resetForm("formEmail");
      this.resetForm("formEmailReg");

      this.isChecked = false;

      this.actionType = Object.assign({}, this.actionType, {
        isChangePwd: false,
        isRegister: false,
        id: item.id,
      });

      this.tabItem = item;
    },
    /**
     * @desc 点击返回登录
     */
    goBackLogin () {
      if (this.regFlag == true) {
        this.regFlag = false
      }
      this.changeTab(this.tabList[1], false);
    },
    stopTelTime () {
      clearInterval(this.timerObj.telTime.obj);
      this.timerObj.telTime.num = 0;
    },
    /* 短信倒计时 */
    timerTelClick (callback) {
      this.stopTelTime();
      this.timerObj.telTime.num = timeMax;

      const TelTickFun = () => {
        --this.timerObj.telTime.num;

        if (this.timerObj.telTime.num <= 0) {
          this.timerObj.telTime.num = 0;
          clearInterval(this.timerObj.telTime.obj);
        }
      }

      TelTickFun();

      this.timerObj.telTime.obj = setInterval(TelTickFun, 1000);
    },
    /* 手机号发送验证码 */
    telCodeFun (formName) {
      this.$refs[formName].validateField("phone", (errorMessage) => {
        if (!errorMessage) {
          if (this.timerObj.telTime.loading) {
            return false;
          }

          this.timerObj.telTime.loading = true;

          telCodeApi({
            phone: this[formName].phone,
            templateType: 101,
          }).then((res) => {
            const { code, message } = res;
            if (code == 200) {
              this.timerTelClick();
            } else {
              this.$message.error(message);
            }
            this.timerObj.telTime.loading = false;
          }).catch(err => {
            this.timerObj.telTime.loading = false;
          });
        } else {
          this.$message.error(errorMessage);
        }
      });
    },
    stopEmailTime () {
      clearInterval(this.timerObj.emailTimer.obj);
      this.timerObj.emailTimer.num = 0;
    },
    /* 邮箱忘记密码 */
    forgetPwd () {
      this.isChecked = true;
      this.actionType = {
        isChangePwd: true,
        isRegister: false,
        id: this.tabItem.id,
      };
      this.stopEmailTime();
    },
    /* 邮箱倒计时 */
    timerEmailClick () {
      this.stopEmailTime();
      this.timerObj.emailTimer.num = timeMax;

      const emailTickFun = () => {
        --this.timerObj.emailTimer.num;

        if (this.timerObj.emailTimer.num <= 0) {
          this.timerObj.emailTimer.num = 0;
          clearInterval(this.timerObj.emailTimer.obj);
        }
      }

      emailTickFun();

      this.timerObj.emailTimer.obj = setInterval(emailTickFun, 1000);
    },
    /* 邮箱发送验证码：邮箱注册、邮箱修改密码 */
    emailCodeFun (formName) {
      this.$refs[formName].validateField("email", (errorMessage) => {
        if (!errorMessage) {
          const { isChangePwd, isRegister } = this.actionType;

          let params = {
            email: this[formName].email,
          };

          if (isChangePwd) {
            params.emailType = 202;
          }

          if (isRegister) {
            params.emailType = 200;
          }

          if (this.timerObj.emailTimer.loading) {
            return false;
          }

          this.timerObj.emailTimer.loading = true;

          emailCodeApi(params).then((res) => {
            const { code, message } = res;
            if (code == 200) {
              this.timerEmailClick();
            } else {
              this.$message.error(message);
            }
            this.timerObj.emailTimer.loading = false;
          }).catch(err => {
            this.timerObj.emailTimer.loading = false;
          });
        } else {
          this.$message.error(errorMessage);
        }
      });
    },
    submitForm (type) {
      let formName = "";
      const { id } = this.tabItem;
      let fromData = {};
      if (this.inviteCode) {
        fromData.inviteCode = this.inviteCode
      }
      let successText = '';
      let Api = null;

      if (type == "login") {
        /* 登录 */
        formName = this.tabItem.formName;

        if (id == this.tabList[0].id) {
          /* 手机号登录 */
          Api = telLoginApi;
          fromData.templateType = 101;
        } else if (id == this.tabList[1].id) {
          /* 邮箱登录 */
          Api = emailLoginApi;
          fromData.emailType = 201;
          fromData.type = 1;
        }

        if (!this.isChecked) {
          this.$message.error("请阅读并同意相关协议");
          return false;
        }
      } else if (type == "register") {
        successText = '注册成功';
        /* 注册,只有邮箱注册 */
        formName = this.tabItem.id === this.tabList[1].id ? "formEmailReg" : "";
        /* 邮箱注册 */
        if (formName === "formEmailReg") {
          /* 判断两次密码是否一置 */
          let { newPwd, oldPwd } = this[formName];
          newPwd = newPwd.replace(/\s/g, "");
          oldPwd = oldPwd.replace(/\s/g, "");

          if (newPwd !== oldPwd) {
            this.$message.error("两次密码不一致");
            return false;
          } else {
            fromData.password = newPwd;
          }

          if (!this.isChecked) {
            this.$message.error("请阅读并同意相关协议");
            return false;
          }

          Api = emailLoginApi;
          fromData.emailType = 200;
          fromData.type = 0;
        }
      } else if (type == "pwd") {
        successText = '修改密码成功';
        /* 修改密码，只有邮箱有 */
        formName = this.tabItem.id === this.tabList[1].id ? "formEmailReg" : "";
        /* 邮箱修改密码 */
        if (formName === "formEmailReg") {
          /* 判断两次密码是否一置 */
          let { newPwd, oldPwd } = this[formName];
          newPwd = newPwd.replace(/\s/g, "");
          oldPwd = oldPwd.replace(/\s/g, "");

          if (newPwd !== oldPwd) {
            this.$message.error("两次密码不一致");
            return false;
          } else {
            fromData.password = newPwd;
          }

          Api = emailPwdApi;
          fromData.emailType = 202;
          fromData.type = 0;
        }
      }

      let params = Object.assign({}, this[formName], fromData);

      this.$refs[formName].validate((valid, error) => {
        if (valid) {
          /**
           * @desc 登录请求
           */
          Api(params).then((res) => {
            if (res.code == 200) {
              if (successText) {
                this.$message.success(successText);
              }
              this.SET_USER_INFO({ token: res.data });
              myAccountApi().then((k) => {
                this.SET_USER_INFO(k.data);
                this.SET_USER_INFO({ token: res.data });
                sessionStorage.setItem('memberState', k.data.memberState)
                sessionStorage.setItem('memberType', k.data.memberType)
              })
              this.resetForm(formName);
              if (type == "login") {
                if (this.redirect == '/member') {
                  this.$router.push('/memberLogined')
                } else {
                  this.$router.push('/memberLogined')
                }


              } else {
                this.goBackLogin();
              }
            }
          });
        } else {
          try {
            let keys = Object.keys(error);
            if (keys.length) {
              let key = keys[0];
              this.$message.error(error[key][0].message);
            }
          } catch (err) {
            this.$message.error("表单效验失败");
          }

          // console.log("error submit!!");
          return false;
        }
      });
    },
    registerFun () {
      // console.log('i');
      if (this.regFlag == false) {
        this.regFlag = true
      }

      this.isChecked = false;
      this.actionType = {
        isChangePwd: false,
        isRegister: true,
        id: this.tabItem.id,
      };
      this.stopEmailTime();
    },
    // 对话框
    agreeProtocol () {
      if (this.dialogTableVisible) {
        this.dialogTableVisible = false;
        this.isChecked = true;
      } else {
        this.dialogTableVisible = false;
      }
    },
    otherLogin (type) {
      if (!this.isChecked) {
        this.$message.error("请阅读并同意相关协议");
        return false;
      }

      otherLoginApi(type, { bind: 0, marker: this.redirect || 'symbol' }).then(res => {
        if (res.code == 200) {
          window.location.href = res.data;
        }
      });
    },
    resetForm (formName) {
      if (this.$refs[formName]) {
        this.$refs[formName].resetFields();
      }
    },
    /**
    * @desc 联系我们
    */
    contactUs () {
      this.ishidden = true
    },
    handleClickontactUs () {
      this.ishidden = false
    },
    /**
     * @desc 商务合作
     */
    cooperation () {
      this.ishiddation = true
    },
    handleClickation () {
      this.ishiddation = false
    },
    /**
     * @desc 赚取积分
     */
    earnPoints () {
      this.$message({
        type: 'error',
        message: '请先登录后再赚取积分！'
      })
      const loginForm = this.$refs.loginForm;
      loginForm.scrollIntoView(false);
    },
    /**
     * @desc 常见问题
     */
    problemFn () {
      const targetLocation = this.$refs.targetLocation;
      targetLocation.scrollIntoView();
    }


  },
}
</script>

<style lang="less" scoped>
.memberWrap {
  width: 100vw;
  background-color: rgb(29 33 41);
  overflow-x: auto;
  user-select: none;

  .memberBox {
    width: 100vw;
    margin: auto;

    .memberHeader {
      height: 900px;
      background-image: url("../assets/member/headerBg.jpg");
      background-repeat: no-repeat;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: center;

      .memberTitle {
        width: 550px;
        height: 100px;
        text-align: center;
        line-height: 80px;
        user-select: none;
        color: rgb(255, 255, 255);
        margin-left: -100px;

        h1 {
          font-size: 3.5rem;
          font-weight: 700;
        }

        span {
          font-size: 1.2rem;
          transform: translateX(-20px);
          font-weight: 500;
        }
      }

      .loginForm {
        width: 550px;
        height: 550px;
        background-color: rgb(18, 18, 18);
        border-radius: 1.5rem;
        border: 1px solid #e0b58c;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        color: aliceblue;
        margin-left: 80px;

        h1 {
          font-size: 2.4rem;
          font-weight: 700;
          margin: 60px 0 10px 0;
        }

        p {
          font-size: 1rem;
          font-weight: 400;
          margin: 10px 0 20px 0;
        }

        .formArea {
          width: 100%;
          height: 460px;

          .fromBox {
            width: 100%;
            height: 350px;

            .chgetab {
              cursor: pointer;
              width: 100%;
              height: 30px;
              display: flex;
              flex-direction: row;
              justify-content: center;
              line-height: 30px;
              margin-bottom: 20px;

              li {
                margin: 0 20px;
                text-align: center;
                width: 65px;
                height: 100%;
              }

              .act {
                border-bottom: 2px solid #ff9900;
              }
            }

            .form {
              position: relative;

              .phoneLoginForm {
                width: 100%;
                height: 300px;

                .formitem {
                  margin: 10px 0 15px 100px;
                  width: 350px;
                }

                .formitem_telcode {
                  position: relative;

                  .telcode {
                    cursor: pointer;
                    position: absolute;
                    right: 10px;
                    color: #eee9e9;
                    font-size: 14px;
                    scale: 0.9;
                  }
                }

                .formitem_inviteCode {
                  position: relative;

                  .invitecode {
                    cursor: pointer;
                    position: absolute;
                    right: 10px;
                    color: #eee9e9;
                    font-size: 14px;
                    scale: 0.9;
                  }
                }
              }

              .emailLoginForm {
                width: 100%;
                height: 300px;
                position: relative;

                .formitem {
                  margin: 20px 0 20px 100px;
                  position: absolute;
                  top: 20px;
                  width: 350px;
                  position: relative;

                  .forgetpwd {
                    cursor: pointer;
                    position: absolute;
                    right: 10px;
                    color: #eee9e9;
                    font-size: 14px;
                    scale: 0.9;
                  }
                }

                .formitem_email {
                  position: absolute;
                  top: 0px;
                }

                .formitem_password {
                  position: absolute;
                  top: 80px;
                }
              }

              .ischeck {
                width: 100%;
                height: 30px;
                position: absolute;
                top: 180px;
                line-height: 30px;

                .checkbox {
                  margin: 0 8px 0 105px;
                }

                span,
                a {
                  color: #b1b1b1;
                  font-size: 12px;
                }

                a {
                  color: #f56c6c;
                }

                .checkbox_reg {
                  position: absolute;
                  left: 100px;
                  top: 45px;
                }

                .reg_1 {
                  position: absolute;
                  left: 120px;
                  top: 44px;
                }

                .reg_2 {
                  position: absolute;
                  left: 200px;
                  top: 44px;
                }
              }

              .btn {
                position: absolute;
                top: 240px;
                left: 100px;
                width: 350px;
                height: 38px;
                line-height: 38px;
                background-color: #ff9900;
                border-radius: 10px;
                border: none;
                color: #000;
                font-size: 22px;
                font-weight: 600;
                cursor: pointer;
              }

              .btn_reg {
                position: absolute;
                top: 262px;
                left: 100px;
                width: 350px;
                height: 38px;
                line-height: 38px;
                background-color: #ff9900;
                border-radius: 10px;
                border: none;
                color: #000;
                font-size: 22px;
                font-weight: 600;
              }

              .registerRight {
                position: absolute;
                right: 110px;
                bottom: -8px;
                font-size: 16px;
                color: #b1b1b1;
              }

              .backlogin {
                position: absolute;
                right: 108px;
                bottom: -14px;
                font-size: 14px;
                color: #b1b1b1;
              }

              .registerForm {
                width: 100%;
                height: 310px;
                margin-top: -10px;

                .formitem {
                  margin: 5px 0 5px 100px;
                  width: 350px;
                  position: relative;

                  .emailcode {
                    position: absolute;
                    right: 10px;
                    cursor: pointer;
                    color: #eee9e9;
                    font-size: 14px;
                    scale: 0.9;
                  }

                  .invitecode {
                    position: absolute;
                    right: 10px;
                    cursor: pointer;
                    color: #eee9e9;
                    font-size: 14px;
                    scale: 0.9;
                  }
                }
              }
            }
          }

          .otherlogin {
            display: flex;
            flex-direction: row;
            width: 100%;
            height: 100px;

            .otherlogintxt {
              color: #b1b1b1;
              font-size: 12px;
              margin: 20px 30px 0 102px;
            }

            ul {
              display: flex;
              flex-direction: row;
            }

            ul li {
              width: 28px;
              height: 28px;
              border-radius: 50%;
              background-color: #fff;
              position: relative;
              margin: 12px 12px 0 0;
            }

            ul .wechat img {
              width: 28px;
              cursor: pointer;
            }

            ul .QQicon img {
              width: 34px;
              position: absolute;
              top: -2.8px;
              left: -3px;
              cursor: pointer;
            }

            .link-code {
              position: relative;

              img {
                position: absolute;
                top: -90px;
                right: -25px;
                width: 100px;
                height: 100px;
                box-shadow: 0px 0.5px 10px rgba(0, 0, 0, 0.5);
              }

              span {
                cursor: pointer;
                color: #909090;
                font-size: 12px;
                margin-left: 110px;
                display: inline-block;
                margin-top: 24px;
              }
            }
          }
        }
      }
    }

    .memberPrice {
      height: 900px;
      background-color: rgb(29 33 41);
      display: flex;
      flex-direction: column;
      align-items: center;

      .priceTitle {
        h1 {
          font-size: 3rem;
          font-weight: 700;
          color: aliceblue;
          margin-top: 80px;
          text-align: center;
        }

        p {
          font-size: 1.125rem;
          font-weight: 400;
          color: aliceblue;
          margin-top: 30px;
          text-align: center;
        }
      }

      .priceList {
        position: relative;
        top: 60px;
        display: flex;
        flex-direction: row;

        .priceItem {
          margin: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          align-items: center;
          width: 400px;
          height: 514px;
          background-color: #ffffff14;
          border-radius: 1.5rem;

          .vipType {
            position: absolute;
            top: 50px;
            color: #ffffff99;
            font-size: 1.25rem;
            font-weight: 700;
          }

          .vipPrice {
            position: absolute;
            top: 100px;
            color: #fff;
            font-size: 2.5rem;
            font-weight: 700;
          }

          .vipDesc {
            position: absolute;
            top: 200px;

            .descItem {
              margin: 20px 0;
              color: #fff;
              font-size: 1rem;
              font-weight: 400;

              img {
                width: 7%;
                vertical-align: middle;
                margin-right: 10px;
                -webkit-user-drag: none;
              }
            }
          }

          .buyNowBtn {
            border: none;
            width: 300px;
            height: 3.25rem;
            position: absolute;
            bottom: 50px;
            border-radius: 2.5rem;
            background-color: rgb(255, 153, 0);
            color: #000;
            font-size: 1.2rem;
            font-weight: 500;
            cursor: pointer;
          }
        }

        .active {
          background-color: rgb(255, 153, 0);
          box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);
          //transform: translateY(-1.08rem);
          transition: all 0.5s ease;
          transform: scale(1.1) translateY(-1.08rem);

          .vipType,
          .vipPrice,
          .vipDesc .descItem {
            color: #000;
          }

          .vipDesc .descItem img {
            -webkit-user-drag: none;
            color: #000;
          }

          .buyNowBtn {
            background-color: #ff26058c;
          }
        }
      }
    }

    .vipMemberRight {
      height: 900px;
      background-color: rgb(29 33 41);
      display: flex;
      flex-direction: column;
      align-items: center;

      .priceTitle {
        h1 {
          font-size: 3rem;
          font-weight: 700;
          color: aliceblue;
          text-align: center;
        }

        p {
          font-size: 1.125rem;
          font-weight: 500;
          color: aliceblue;
          margin-top: 30px;
          text-align: center;
        }
      }

      .memberRightBottom {
        user-select: none;
        width: 84rem;
        height: 35rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .memRightType {
          width: 26.25rem;
          height: 30rem;
          color: #fff;
          flex: 1;

          li {
            font-size: 1rem;
            font-weight: 500;
            width: 20rem;
            height: 4rem;
            background-color: #ffffff14;
            border-radius: 0.35rem;
            margin-bottom: 0.3rem;
            line-height: 4rem;
            padding-left: 1.5rem;
            box-sizing: border-box;
          }
        }

        .ordinaryUser {
          width: 26.25rem;
          height: 30rem;
          color: #fff;
          flex: 1;
          margin-left: 0.27rem;
          margin-right: -2rem;

          li {
            text-align: center;
            font-size: 1rem;
            font-weight: 500;
            width: 15rem;
            height: 4rem;
            line-height: 4rem;
            margin-bottom: 0.3rem;
            background-color: #ffffff14;
            border-radius: 0.35rem;
          }
        }

        .act {
          li {
            transition: all 0.2s ease;
            background-color: #ff9900;
            color: #000;
          }
        }

        .vipMemberWrap {
          width: 46rem;
          flex: 1;
          display: flex;
          margin-left: 0.27rem;

          .vipMemberList {
            flex: 1;
            width: 26.25rem;
            height: 30rem;
            color: #fff;
            margin-left: -2.4rem;

            li {
              text-align: center;
              font-size: 1rem;
              font-weight: 600;
              width: 15rem;
              height: 4rem;
              line-height: 4rem;
              margin-bottom: 0.3rem;
              background-color: #ffffff14;
              border-radius: 0.35rem;

              img {
                width: 10%;
                -webkit-user-drag: none;
              }
            }
          }

          .act {
            li {
              background-color: #ff9900;
              color: #000;
            }
          }
        }
      }
    }

    .MembershipPiv {
      width: 100%;
      height: 850px;
      background-color: rgb(29 33 41);
      display: flex;
      flex-direction: column;
      align-items: center;

      .MembershipPivTitle {
        margin-top: 55px;

        h1 {
          font-size: 3rem;
          font-weight: 700;
          color: aliceblue;
          text-align: center;
        }

        p {
          font-size: 1.125rem;
          font-weight: 500;
          color: aliceblue;
          margin-top: 30px;
          text-align: center;
          margin-bottom: 60px;
        }
      }

      .MembershipType {
        user-select: none;
        width: 84rem;
        height: 40rem;

        ul {
          text-align: center;
          width: 84rem;
          height: 40rem;
          color: #fff;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: space-around;

          li {
            width: 330px;
            height: 240px;

            .MembershipPic {
              width: 8rem;
              height: 8rem;
              line-height: 10rem;
              background-color: #000;
              border-radius: 50%;
              margin-left: 100px;
              margin-bottom: 30px;
            }

            .MembershipName {
              margin-left: 10px;
              font-size: 1.8rem;
              margin-bottom: 50px;
            }

            .MembershipValue {
              color: #ffffff99;
              font-size: 0.8rem;
              margin-left: 10px;
              margin-bottom: 150px;
            }
          }
        }
      }
    }

    .MembershipArea {
      width: 100%;
      height: 500px;
      background-color: rgb(29 33 41);
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      color: #ffffff;

      .memberShipAreaModel {
        width: 320px;
        height: 320px;
        background-color: #ffffff14;
        border-radius: 5%;
        margin: 0 10px;
        border: 1px solid #ffffff1a;

        .memberShipAreaModelTitle {
          padding-left: 30px;
          padding-top: 32px;
          box-sizing: border-box;
          margin-bottom: 25px;

          .ipt img {
            width: 16%;
            vertical-align: middle;
            margin-top: -8px;
            -webkit-user-drag: none;
          }

          .ipt1 img {
            width: 12%;
            vertical-align: middle;
            margin-top: -8px;
            -webkit-user-drag: none;
          }

          .txt {
            font-size: 24px;
            font-weight: 700;
            margin-left: 20px;
          }
        }

        p {
          margin-left: 30px;
          font-size: 16px;
          font-weight: 500;
          line-height: 32px;
        }

        .OpenImmediae {
          width: 119px;
          height: 40px;
          border-radius: 40px;
          background-color: #ff9900;
          color: #000;
          text-align: center;
          line-height: 40px;
          font-size: 14px;
          font-weight: 500;
          margin-left: 30px;
          margin-top: 30px;
          cursor: pointer;

          span {
            color: #fff;
            font-size: 16px;
            margin-left: 5px;
            font-weight: 700;
          }
        }
      }
    }

    .helpCenter {
      width: 100%;
      height: 500px;
      background-color: rgb(29 33 41);
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #fff;

      .helpCenterTitle {
        h1 {
          font-size: 3rem;
          font-weight: 700;
          color: aliceblue;
          text-align: center;
        }

        p {
          font-size: 1.125rem;
          font-weight: 500;
          color: aliceblue;
          margin-top: 30px;
          text-align: center;
          margin-bottom: 60px;
        }
      }

      .helpCenterContentTitle {
        font-weight: 500;
      }

      .helpCenterContent {
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
        box-sizing: border-box;
        position: relative;

        .code {
          position: absolute;
          top: -120px;
          left: 45px;
          width: 110px;
          background-image: url('../assets/member/layerBgpng.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          padding: 20px;
          margin-right: 10px;

          &:last-child {
            margin-right: 0;
          }

          img {
            display: block;
            width: 100px;
            margin: 0 auto;

          }

          p {
            font-size: 14px;
            color: #969696;
            padding: 6px 7px;
            text-align: center;
            white-space: nowrap;
          }
        }

        .code_1 {
          position: absolute;
          top: -130px;
          left: 310px;
          width: 110px;
          background-image: url('../assets/member/layerBgpng.png');
          background-size: 100% 100%;
          padding: 22px;
          margin-right: 10px;

          &:last-child {
            margin-right: 0;
          }

          img {
            display: block;
            width: 100px;
            margin: 0 auto;
            padding-top: 6px;
          }

          p {
            font-size: 14px;
            color: #969696;
            padding: 6px 7px;
            text-align: center;
            white-space: nowrap;
          }
        }

        .helpCenterContentBox {
          width: 240px;
          height: 200px;
          background-color: #ffffff14;
          border-radius: 24px;
          border: 1px solid #ffffff29;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-top: 50px;
          box-sizing: border-box;
          margin-top: 50px;
          margin-right: 20px;

          .ipt img {
            margin-bottom: 20px;
            -webkit-user-drag: none;
          }

          p {
            font-size: 24px;
            font-weight: 700;
          }
        }
      }
    }

    .usualQuest {
      height: 900px;
      background-color: rgb(29 33 41);
      color: #fff;

      .usualQuestTitle {
        width: 64.5rem;
        height: 6.875rem;
        margin: 0 auto;
        border-bottom: 1px solid #a6a6a6;
        margin-bottom: 3.125rem;

        h1 {
          font-size: 3rem;
          font-weight: 700;
          color: aliceblue;
          text-align: center;
        }

        p {
          font-size: 30px;
          font-weight: 700;
          color: #a6a6a6;
          margin-top: 10px;
          text-align: center;
          margin-bottom: 60px;
        }
      }

      .usualQuestContent {
        width: 64rem;
        margin: 0 auto;
        font-size: 1.125rem;
        font-weight: 500;
        line-height: 1.875rem;
        color: #fff;

        a {
          color: #ff9900;
          border-bottom: 1px solid #ff9900;
          cursor: pointer;
        }
      }
    }
  }
}

/deep/.el-input__inner {
  border: none !important;
  line-height: 2.25rem !important;
  color: rgb(255, 255, 255);
  -webkit-text-fill-color: #fff !important;
  background-color: #ffffff1a !important;
  transition: background-color 50000s ease-in-out 0s;
  caret-color: rgb(255, 255, 255);
  border-radius: 0.75rem;
  width: 116%;
  height: 2.25rem !important;
  font-size: 0.86rem;
}

/deep/.el-form-item__error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 20px;
}
</style>